
import router from '@/router';
import { Whitelabel, whitelabels } from '../../utils/whitelabels';
import { Component, Vue, Watch } from 'vue-property-decorator';

import CPAlertsSummary from '@/components/globals/CPAlertsSummary.vue';
import logger from '@/logger/logging-button';
import { ActionType } from '@/utils/logTypes';

interface Alerts {
  notifications: Notification[];
  active: boolean;
  checked: boolean;
}

interface Notification {
  id: number;
  type: string;
  title: string;
}

@Component({
  components: {
    CPAlertsSummary,
  },
})
export default class CPNavigation extends Vue {
  public dropdown: boolean = false;
  public alerts: Alerts = {
    active: false,
    checked: false,
    notifications: [
      {
        id: 343964,
        type: 'success',
        title: 'Gain target reached on "Morgan Stanley Global Opp A USD Acc"',
      },
      {
        id: 234923,
        type: 'warning',
        title:
          'Fall target reached on "Unicorn UK Income A Inc GBP Inc GB00B00Z1S94"',
      },
      {
        id: 550304,
        type: 'warning',
        title:
          'Fall target reached on "Unicorn UK Income A Inc GBP Inc GB00B00Z1S94"',
      },
    ],
  };

  public whitelabel: Whitelabel = whitelabels[0];

  get subdomain() {
    return this.$store.state.subdomain;
  }

  get userRole(): string {
    return this.$store.state.account.details.role;
  }
  get isLoggedIn(): string {
    return this.$store.state.account.token;
  }
  get username(): string {
    return this.$store.state.account.details.name &&
      this.$store.state.account.details.name.length > 15
      ? this.$store.state.account.details.name.substr(0, 15 - 1) + '...'
      : this.$store.state.account.details.name;
  }

  get moventumId(): string {
    return this.$store.state.account.accountSummary.moventumId;
  }

  public get cart() {
    return this.$store.state.baskets.cart.items;
  }

  get isNetworkAdminUser(): boolean {
    const roles = this.userRole || [];
    return roles.includes('networkadmin');
  }

  get isNetworkAdminImpersonation(): boolean {
    const impersonatorRoles =
      this.$store.state.account.details.impersonatorRoles || [];
    return (
      this.$store.state.account.details.roleType === 'impersonated' &&
      impersonatorRoles.includes('networkadmin')
    );
  }

  public async logout() {
    if (
      router.history.current.name === 'Open Account' &&
      !confirm(
        'Are you sure you want to leave the account opening section? Any unsaved progress on the current step will be lost',
      )
    ) {
      logger.loggingButtonWarn(
        'click',
        ActionType.LOGIN,
        'logout',
        'cancel logout',
      );
      return;
    }

    await this.log(ActionType.LOGOUT, 'logout');
    // If CPHQ user - clear any client info + logout
    if (
      this.$store.state.account.details.cphqUser ||
      this.$store.state.account.details.roleType === 'impersonated'
    ) {
      this.$store.dispatch('clearClientToken');
    } else {
      this.$store.dispatch('logout');
    }
  }
  public onRouterLinkClicked(name: string) {
    this.log(ActionType.OTHER, name);
  }

  public async log(action: ActionType, name: string) {
    logger.loggingButtonExtra('click', action, name, {
      component: this.$options.name,
    });
  }

  public openWatchlist() {
    this.$store.commit('toggleWatchlist', true);
    this.log(ActionType.PAGE_UPDATE, 'Watchlist');
  }
  public openAlerts() {
    this.$store.commit('toggleAlerts', true);
    this.log(ActionType.PAGE_UPDATE, 'Alert');
  }
  public openCart() {
    this.$store.dispatch('toggleCart', true);
    this.log(ActionType.PAGE_UPDATE, 'Cart');
  }

  @Watch('subdomain')
  public updateWhitelabel() {
    if (!this.subdomain) {
      this.whitelabel = whitelabels[0];
    } else {
      const companyIndex = whitelabels
        .map((x) => x.name())
        .indexOf(this.subdomain);
      this.whitelabel = whitelabels[companyIndex];
    }
  }

  public mounted() {
    this.updateWhitelabel();
  }
}
